
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";

@Component
export default class MultiInput extends Mixins(formMixin, formOptionsMixin, formValidationMixin) {
  @Prop({ default: "text" })
  type: string;

  @Prop({ default: true })
  showClear: boolean;

  reset() {
    this.localValue = "";
  }
}
